import { Command } from 'commands/Commands';

export class ChangeMemberInstagramVisibility extends Command {
  type: string = 'Member.ChangeInstagramVisibility';
  priority = 100;
}
